import {useCallback, useMemo} from "react";
import {CONSOLE_HOST, WEB_HOST} from "../core/variables";

const useLinkHandler = () => {
    const linkToLogin = useCallback((subPath?: string) => {
        if (subPath) {
            window.location.href = `${CONSOLE_HOST}/login?redirectPath=${subPath}`;
        } else {
            window.location.href = `${CONSOLE_HOST}/login?redirectPath=${WEB_HOST}`;
        }
    }, []);

    const linkToSignUp = useCallback(() => {
        window.location.href = `${CONSOLE_HOST}/signup`;
    }, [])

    const linkToChannelList = useCallback(() => {
        window.location.href = `${CONSOLE_HOST}/channels`;
    }, [])

    const linkToOnboarding = useCallback((channelId?: string, invitation?: string) => {
        if (channelId) {
            window.location.href = `${CONSOLE_HOST}/channels/${channelId}/onboarding${invitation || ''}`;
        } else {
            window.location.href = `${CONSOLE_HOST}/onboarding`;
        }
    }, [])

    const linkToFreeOnboarding = useCallback(() => {
        window.location.href = `${CONSOLE_HOST}/onboarding`;
    }, [])

    const linkToRoot = useCallback( () => {
        window.location.href = `${CONSOLE_HOST}/channels`;

    }, [])

    return useMemo(() => {
        return {
            linkToLogin,
            linkToSignUp,
            linkToChannelList,
            linkToOnboarding,
            linkToFreeOnboarding,
            linkToRoot
        }
    }, [
        linkToLogin,
        linkToSignUp,
        linkToChannelList,
        linkToOnboarding,
        linkToFreeOnboarding,
        linkToRoot
    ])
}

export default useLinkHandler;
